import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import { API } from "redux/api"
import i18n from "config/i18n"
import { ClientConfirmEmailValues } from "types"

export const resendEmailConfirmation = createAsyncThunk(
  "client/resend-email-confirmation",
  async () => {
    const response = await API.post("/client/confirm_email/resend")
    return response.data
  },
)

export const cancelEmailConfirmation = createAsyncThunk(
  "client/cancel-email-confirmation",
  async () => {
    const response = await API.post("/client/confirm_email/reset")
    return response.data
  },
)

export const confirmEmail = createAsyncThunk(
  "client/confirm-email",
  async (values: ClientConfirmEmailValues) => {
    const response = await API.post("/client/confirm_email", values)
    return response.data
  },
)

export const makeResendEmailConfirmation = () => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(resendEmailConfirmation())
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.email.resend.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(i18n.t("notice.confirmation.email.resend.success"))
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.email.resend.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export const makeCancelEmailConfirmation = () => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(cancelEmailConfirmation())
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.email.cancel.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(i18n.t("notice.confirmation.email.cancel.success"))
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.email.resend.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export const makeEmailConfirmation = (values: ClientConfirmEmailValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(confirmEmail(values))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.email.confirm.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(
                i18n.t("notice.confirmation.email.confirm.success"),
              )
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.email.confirm.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
